module.exports = __webpack_public_path__ + "static/media/bg5.d1571425.jpg";